/**
 * 操作客服记录
 */
import React, { useState, useEffect, useRef } from "react";
import { Alert, Modal, Form, Input, message, Select, Switch, Radio, Divider, Table } from "antd";
import {
  addServiceRecoed,
  serviceRecoedRequest,
  addServiceRecoedBatch,
  customerRecordHistoryRequest,
  CustomerRecordHistoryDto,
} from "@/service/carDiagnosis";
import { tagListRequest, auditStatusEnumRequest } from "@/service/tagManage";
import { TagCategoryEnum } from "@/constants/tagManage";
import UploadImageVideo from "@/components/uploadImageVideo";
import CarSelect from "@/components/carSelect";
import { carListRequest } from "@/service/carManage";
import DatePicker from "@/components/datePicker";
import dayjs from "dayjs";

const { TextArea } = Input;
const reliefClassifyValues = [
  "减/免责情况沟通",
  "减/免责沟通证据",
  "减免责情况沟通",
  "减免责沟通",
  "减免责证据沟通",
];
interface OperateMaintenanceProps {
  type: string;
  data?: any; // 车辆信息
  carId?: any;
  editData?: any;
  onClose: () => void; // 关闭弹窗的方法
  reloadData: () => void; // 添加成功后重新请求客服记录的方法
  anyData: (one: any, two: any) => void;
}

export const concatResultList = [
  { label: "微信沟通", value: "微信沟通" },
  { label: "座机沟通", value: "座机沟通" },
  { label: "手机沟通", value: "手机沟通" },
  { label: "不配合沟通", value: "不配合沟通" },
  { label: "客户未接通", value: "客户未接通" },
  { label: "已对接业务协助", value: "已对接业务协助" },
  { label: "业务已告知情况", value: "业务已告知情况" },
  { label: "业务未告知情况", value: "业务未告知情况" },
  { label: "需内部向上反馈", value: "需内部向上反馈" },
  { label: "派工单", value: "派工单" },
  { label: "需发函", value: "需发函" },
  { label: "自愈", value: "自愈" },
  { label: "未营运", value: "未营运" },
]

const classifyOptions = ["续费沟通", "事故沟通", "减/免责情况沟通", "日常沟通"];
const serviceTaskPictureFields = [
  { keyField: "dmsPicKey", bucketField: "dmsPicBucket", urlField: "dmsPicUrl" },
  { keyField: "adasPicKey", bucketField: "adasPicBucket", urlField: "adasPicUrl" },
  { keyField: "bsdPicKey", bucketField: "bsdPicBucket", urlField: "bsdPicUrl" },
];

const OperateService = (props: OperateMaintenanceProps) => {
  const { type, carId, data, editData, onClose, reloadData, anyData } = props;
  const [loading, setLoading] = useState<boolean>(false); // 接口是否请求中
  const [serviceProblemType, setServiceProblemType] = useState<any>([]); // 问题来源的标签
  const [carOffLineCauseType, setCarOffLineCauseType] = useState<any>([]); // 车辆离线原因
  const [carRelationResult, setCarRelationResult] = useState<any>([]); // 车辆联系结果
  const [tagData, setTagData] = useState<any>([]); // 问题原因的标签
  const [uploadSuccessList, setUploadSuccessList] = useState<any>([]); // 上传成功的图片信息
  const [autoCarryUploadFiles, setAutoCarryUploadFiles] = useState<any[]>([]); // 客服任务自动带入的图片
  const [uploadFilesVersion, setUploadFilesVersion] = useState(0); // 刷新上传组件默认文件
  const [form] = Form.useForm();
  const [submitNoRepetition, setSubmitNoRepetition] = useState(true); // 不能重复请求
  const [serviceTaskDisposeEdit, setServiceTaskDisposeEdit] = useState<any>([]); // 客服任务编辑客服记录
  const [ifUploadImageVideo, setIfUploadImageVideo] = useState(false); // 是否上传图片或视频
  const [uploadTouched, setUploadTouched] = useState(false); // 是否手动变更过上传内容
  const [carPredictWorkTime, setCarPredictWorkTime] = useState<any>([]); // 预计复工时间
  const [expectedTime, setExpectedTime] = useState<boolean>(false);
  const [sellCar, setSellCar] = useState<boolean>(false);
  const [pendingApprovalStatus, setPendingApprovalStatus] = useState<any>();
  const [approvedApprovalStatus, setApprovedApprovalStatus] = useState<any>();
  const [rejectedApprovalStatus, setRejectedApprovalStatus] = useState<any>();
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyList, setHistoryList] = useState<CustomerRecordHistoryDto[]>([]);
  const autoCarryPromptedRef = useRef(false);
  const showUploadImageVideoRef = useRef(false);
  const classifyValue = Form.useWatch("classify", form);
  const typesValue = Form.useWatch("types", form);
  const addModalTypes = [
    "add",
    "carDiagnosisAdd",
    "serviceTaskDisposeAdd",
    "serviceTaskBatchAdd",
    "serviceRecordAdd",
  ];
  const editModalTypes = ["edit", "serviceTaskDisposeEdit"];
  const isAddMode = addModalTypes.includes(type);
  const isEditMode = editModalTypes.includes(type);
  const currentEditRecord =
    type === "edit"
      ? editData
      : type === "serviceTaskDisposeEdit"
        ? serviceTaskDisposeEdit
        : undefined;

  const normalizeText = (value: any) => String(value || "").replace(/\s+/g, "");
  const isReliefClassify = (value: any) =>
    reliefClassifyValues.includes(String(value || "").trim());
  const matchesApprovalStatus = (
    value: any,
    targetStatus: any,
    fallbackLabels: string[] = [],
  ) => {
    if (targetStatus !== undefined && targetStatus !== null) {
      return value === targetStatus;
    }
    const normalizedValue = normalizeText(value);
    return fallbackLabels.some((label) => normalizeText(label) === normalizedValue);
  };
  const isApprovedApproval = (value: any) =>
    matchesApprovalStatus(value, approvedApprovalStatus, ["审批通过", "APPROVED"]);
  const isPendingApproval = (value: any) =>
    matchesApprovalStatus(value, pendingApprovalStatus, ["待审批", "PENDING"]);
  const isRejectedApproval = (value: any) =>
    matchesApprovalStatus(value, rejectedApprovalStatus, ["审批拒绝", "审核不通过", "REJECTED"]);
  const getDefaultContent = (content?: string, taskData?: any) => {
    const normalizedContent = String(content || "").trim();
    if (normalizedContent) {
      return content;
    }
    return [
      taskData?.masterProblem ? `主问题：${taskData.masterProblem}` : "",
      taskData?.slaveProblem ? `次问题：${taskData.slaveProblem}` : "",
      taskData?.ex ? `车辆情况说明：${taskData.ex}` : "",
    ]
      .filter(Boolean)
      .join("\n");
  };
  const getSelectedTypeLabels = (selectedTypes: any[] = []) => {
    return (selectedTypes || []).map((selectedType) => {
      const matched = tagData.find(
        (item: any) => item.value === selectedType || item.label === selectedType,
      );
      return matched?.label ?? selectedType;
    });
  };
  const checkPhotoRequired = (values: any) => {
    const selectedTypeLabels = getSelectedTypeLabels(values?.types);
    const hasDmsCameraOcclusionProblem = selectedTypeLabels.some(
      (item) => normalizeText(item) === normalizeText("DMS相机异常（遮挡）"),
    );
    return isReliefClassify(values?.classify) || hasDmsCameraOcclusionProblem;
  };
  const currentViewResources =
    type === "edit"
      ? editData?.viewResources
      : type === "serviceTaskDisposeEdit"
        ? serviceTaskDisposeEdit?.viewResources
        : [];
  const defaultUploadFiles = Array.isArray(currentViewResources)
    ? currentViewResources.map((item: any) => ({
      contentType: item.contentType,
      key: new URL(item.url).pathname.slice(1),
      preview: item.url,
      bucket: item.bucket ?? null,
    }))
    : [];
  const uploadDefaultFiles = [...defaultUploadFiles, ...autoCarryUploadFiles];
  const photoRequired = checkPhotoRequired({
    classify: classifyValue,
    types: typesValue,
  });
  const isPendingRestrictedEditRecord =
    isEditMode &&
    isReliefClassify(classifyValue ?? currentEditRecord?.classify) &&
    isPendingApproval(currentEditRecord?.approvalStatus);
  const isApprovedEditRecord =
    isEditMode && isApprovedApproval(currentEditRecord?.approvalStatus);
  const isRejectedEditRecord =
    isEditMode && isRejectedApproval(currentEditRecord?.approvalStatus);
  const isFormDisabled = isApprovedEditRecord || isPendingRestrictedEditRecord;
  const historyCustomerRecordId = currentEditRecord?.id;
  const hasUploadFiles = uploadTouched
    ? uploadSuccessList.length > 0
    : uploadDefaultFiles.length > 0;
  const showUploadImageVideo = ifUploadImageVideo || photoRequired || hasUploadFiles || sellCar;
  const formGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    columnGap: 16,
  } as const;

  useEffect(() => {
    getServiceProblemType();
    getWorkOrderTags();
    getCarOffLineCauseType();
    getCarPredictWorkTime();
    getCarRelationResult();
    getPendingApprovalStatus();
    edit();
    if (type == "carDiagnosisAdd") {
      form.setFieldsValue({ tel: carId.car_principal_phone });
    }
    if (type == "serviceTaskDisposeAdd") {
      console.log(data);
      form.setFieldsValue({
        plateNumber: data.plateNumber,
        frameNumber: data.frameNumber,
        tel: data.tel,
        contactName:data.carPrincipal,
        contactIdentity:"负责人",
        reason: data.slaveProblem,
        
        content: getDefaultContent(undefined, data),
      });
      if (
        data.type == "故障车辆" ||
        data.type == "监测车辆" ||
        data.type == "离线车辆"
      ) {
        form.setFieldsValue({ category: "指标监测" });
      } else if (data.type == "专项回访") {
        form.setFieldsValue({ category: "日常回访" });
      }
    }
    if (type == "serviceTaskDisposeEdit") {
      taskDisposeEdit();
    }
  }, []);

  useEffect(() => {
    getCustomerRecordHistory();
  }, [historyCustomerRecordId]);

  const getCustomerRecordHistory = async () => {
    if (!historyCustomerRecordId) {
      setHistoryList([]);
      return;
    }
    try {
      setHistoryLoading(true);
      const res = await customerRecordHistoryRequest({
        customerRecordId: historyCustomerRecordId,
      });
      setHistoryList(res.data?.data || []);
    } catch (error) {
      console.log(error);
      setHistoryList([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  // 客服任务编辑客服任务
  const taskDisposeEdit = async () => {
    const res = await serviceRecoedRequest({ taskId: data.id });
    const currentRecord = res.data.data[0] || {};
    const nextRecord = {
      ...currentRecord,
      content: getDefaultContent(currentRecord.content, data),
    };
    if (nextRecord.appointmentType === 0 || nextRecord.appointmentType === "0") {
      nextRecord.appointmentType = undefined;
    }
    form.setFieldsValue(nextRecord);
    setServiceTaskDisposeEdit(nextRecord);
  };

  // 编辑
  const edit = async () => {
    if (type === "edit") {
      const nextEditData = { ...editData };
      if (nextEditData.appointmentType === 0 || nextEditData.appointmentType === "0") {
        nextEditData.appointmentType = undefined;
      }
      form.setFieldsValue(nextEditData);
    }
  };

  // 提交客服记录
  const submit = async (values: any) => {
    if (isFormDisabled) {
      return;
    }
    if (checkPhotoRequired(values) && !hasUploadFiles) {
      message.warning('请上传图片/视频');
      return;
    }
    if (sellCar && !hasUploadFiles) {
      message.warning('卖车状态下必须上传录音');
      return;
    }
    if (submitNoRepetition) {
      setSubmitNoRepetition(false);
      try {
        const params = { ...values };
        // 遗留沟通类型回显：如编辑模式下 classify 为历史值（不在四个选项内），提交时保留原值
        if (type === "edit" && editData?.classify && !classifyOptions.includes(editData.classify)) {
          params.classify = editData.classify;
        }
        // if (params.category == null) {
        //   params.category = '指标监测'
        // }
        //对每个id 进行发送添加客服记录的请求
        if (type == "serviceTaskBatchAdd") {
          params.taskIds = data;
          params.taskState = params.treatmentStateType;
          const res = await addServiceRecoedBatch(params);
          if (res.status == 200) {
            setSubmitNoRepetition(true);
          }
          if (res.data?.code === 0) {
            message.success("添加成功");
            onClose();
            reloadData();
          }
        } else {
          if (type == "carDiagnosisAdd") {
            params.plateNumber = carId.plate_number;
            params.frameNumber = carId.frame_number;
            params.carId = carId.id;
          }
          if (type == "serviceTaskDisposeAdd") {
            const searchParams = {
              page: 1,
              limit: 50,
              plate_number: params.plateNumber,
            };
            const res = await carListRequest(searchParams);
            params.carId = res.data.data[0]?.id;
            params.taskId = data.id;
          }
          if (type == "serviceRecordAdd") {
            const searchParams = {
              page: 1,
              limit: 50,
              plate_number: params.plateNumber,
            };
            const res = await carListRequest(searchParams);
            params.carId = res.data.data[0]?.id;
          }
          if (uploadSuccessList.length) {
            params.resources = uploadSuccessList;
          }
          if (type === "edit") {
            params.id = editData.id;
          }
          if (type === "serviceTaskDisposeEdit") {
            params.id = serviceTaskDisposeEdit.id;
          }
          delete params.treatmentStateType;
          const res = await addServiceRecoed(params);
          if (res.status == 200) {
            setSubmitNoRepetition(true);
          }
          
          if (res.data?.code === 0) {
            if (isEditMode) {
              message.success("编辑成功");
            } else {
              message.success("新增成功");
            }
            onClose();
            reloadData();
            data.resourceViewDtos= params.resources
            console.log(data,"data")
            anyData(data, values);
          }
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
  };

  // 获取问题来源
  const getServiceProblemType = async () => {
    const res = await tagListRequest({
      tagSorts: [TagCategoryEnum.serviceProblemType],
    });
    const tags: any = [];
    (res.data?.data || []).forEach((item: any) => {
      const { title, isDisabled } = item;
      tags.push({ label: title, value: title, disabled: isDisabled === true });
    });
    setServiceProblemType(tags);
  };

  // 获取问题原因
  const getWorkOrderTags = async () => {
    const res = await tagListRequest({
      tagSorts: [TagCategoryEnum.maintainType],
    });
    const tags: any = [];
    const selected: any = [];
    const problemName: any = data?.masterProblem?.split(",") || [];

    (res.data?.data || []).forEach((item: any) => {
      const { title, id, isDisabled } = item;
      tags.push({ label: title, value: id, disabled: isDisabled });
     
      // 如果有主问题， 则默认选中
      if (data?.masterProblem) {   
        if (problemName.includes(title)) {
          selected.push(id)
        }
      }
    });
    // 避免编辑的是否覆盖
    if (!form.getFieldValue('types')) {
      form.setFieldsValue({ types: selected });
    }

    setTagData(tags);
  };

  // 获取车辆离线原因
  const getCarOffLineCauseType = async () => {
    const res = await tagListRequest({
      tagSorts: [TagCategoryEnum.carOffLineCause],
    });
    const tags: any = [];
    (res.data?.data || []).forEach((item: any) => {
      const { title } = item;
      tags.push({ label: title, value: title });
    });
    setCarOffLineCauseType(tags);
  };

  // 获取预计复工时间
  const getCarPredictWorkTime = async () => {
    const res = await tagListRequest({
      tagSorts: [TagCategoryEnum.carPredictWorkTime],
    });
    const tags: any = [];
    (res.data?.data || []).forEach((item: any) => {
      const { title } = item;
      tags.push({ label: title, value: title });
    });
    setCarPredictWorkTime(tags);
  };

  // 获取车辆联系结果
  const getCarRelationResult = async () => {
    const res = await tagListRequest({
      tagSorts: [TagCategoryEnum.carRelationResult],
    });
    const tags: any = [];
    (res.data?.data || []).forEach((item: any) => {
      const { title } = item;
      tags.push({ label: title, value: title });
    });
    setCarRelationResult(tags);
  };

  // 获取待审批审核状态值
  const getPendingApprovalStatus = async () => {
    const res = await auditStatusEnumRequest();
    const pendingStatus = (res.data?.data || []).find(
      (item: any) => normalizeText(item.first) === normalizeText("待审批"),
    )?.second;
    const approvedStatus = (res.data?.data || []).find(
      (item: any) => normalizeText(item.first) === normalizeText("审批通过"),
    )?.second;
    const rejectedStatus = (res.data?.data || []).find(
      (item: any) =>
        normalizeText(item.first) === normalizeText("审批拒绝") ||
        normalizeText(item.first) === normalizeText("审核不通过"),
    )?.second;
    setPendingApprovalStatus(pendingStatus);
    setApprovedApprovalStatus(approvedStatus);
    setRejectedApprovalStatus(rejectedStatus);
  };

  // 选择车辆获取车架号
  const onCarSelect = (value: any, options: any) => {
    form.setFieldsValue({
      frameNumber: options.frame_number,
    });
  };

  const getServiceTaskAutoCarryUploadFiles = () => {
    if (type !== "serviceTaskDisposeAdd" || !data) {
      return [];
    }
    return serviceTaskPictureFields.reduce((files: any[], item) => {
      const key = data[item.keyField];
      const bucket = data[item.bucketField];
      if (!key || !bucket) {
        return files;
      }
      files.push({
        contentType: "image/jpeg",
        key,
        bucket,
        preview: data[item.urlField],
      });
      return files;
    }, []);
  };

  const confirmServiceTaskAutoCarryUploadFiles = () => {
    if (type !== "serviceTaskDisposeAdd" || autoCarryPromptedRef.current) {
      return;
    }

    autoCarryPromptedRef.current = true;
    const carryFiles = getServiceTaskAutoCarryUploadFiles();
    if (!carryFiles.length) {
      return;
    }

    Modal.confirm({
      title: "是否自动带入图片",
      content: "检测到当前任务存在DMS/ADAS/BSD图片，是否自动带入新增客服记录？",
      okText: "确认",
      cancelText: "取消",
      onOk: () => {
        setAutoCarryUploadFiles(carryFiles);
        setUploadSuccessList(carryFiles);
        setUploadTouched(true);
        setUploadFilesVersion((version) => version + 1);
      },
    });
  };

  useEffect(() => {
    if (isReliefClassify(classifyValue)) {
      setIfUploadImageVideo(true);
    }
  }, [classifyValue]);

  useEffect(() => {
    if (showUploadImageVideo && !showUploadImageVideoRef.current) {
      confirmServiceTaskAutoCarryUploadFiles();
    }
    showUploadImageVideoRef.current = showUploadImageVideo;
  }, [showUploadImageVideo]);

  //是否上传视频或图片
  const IfUploadImageVideo = (checked: boolean) => {
    setIfUploadImageVideo(checked);
  };

  const treatmentState = [
    { label: "待处理", value: 12 },
    { label: "待处理-客服", value: 1 },
    { label: "待处理-对接市场", value: 10 },
    { label: "派工单", value: 3 },
    { label: "处理完成", value: 6 },
    { label: "卖车", value: 13 },
    { label: "无法配合", value: 11 },
    { label: "智能体-待处理", value: 9, disabled: true },
    { label: "智能体-已呼叫", value: 2, disabled: true },
  ];

  const sellCarReasonOptions = [
    { label: "合同换签", value: "合同换签" },
    { label: "退出拆除", value: "退出拆除" },
    { label: "考虑中", value: "考虑中" },
    { label: "服务未到期前出现事故无法兜底", value: "服务未到期前出现事故无法兜底" },
  ];

  return (
    <Modal
      title={isAddMode ? "新增客服记录" : "编辑客服记录"}
      visible
      centered
      width={880}
      onCancel={onClose}
      onOk={() => form.submit()}
      okButtonProps={{ loading, disabled: isFormDisabled }}
      maskClosable={false}
      bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
    >
      <Form
        form={form}
        autoComplete="off"
        disabled={isFormDisabled}
        layout="vertical"
        scrollToFirstError
        onFinish={submit}
        initialValues={{ adaptability: "配合", operateMethod: 2 ,contactIdentity:"负责人"}}
      >
        {isFormDisabled && (
          <Alert
            type="warning"
            showIcon
            message={
              isApprovedEditRecord
                ? "当前客服记录已审批通过，输入框和选择框已锁定，无法修改内容。"
                : "当前记录处于待审批状态，减/免责情况沟通暂不支持编辑。"
            }
            style={{ marginBottom: 16 }}
          />
        )}
        {isRejectedEditRecord && (
          <Alert
            type="info"
            showIcon
            message="当前客服记录审批未通过，可继续调整内容和沟通类型后重新提交。"
            style={{ marginBottom: 16 }}
          />
        )}
        <div style={formGridStyle}>
        {carId !== undefined || type == "serviceTaskBatchAdd" ? null : (
          <Form.Item
            label="请选择车辆"
            name="plateNumber"
            rules={[{ required: true, message: "请选择车辆" }]}
          >
            <CarSelect valueField="plate_number" onChange={onCarSelect} disabled={isFormDisabled} />
          </Form.Item>
        )}
        {carId !== undefined || type == "serviceTaskBatchAdd" ? null : (
          <Form.Item
            label="请输入车架号"
            name="frameNumber"
            rules={[{ required: true, message: "请输入车架号" }]}
          >
            <Input placeholder="请输入车架号" />
          </Form.Item>
        )}
        <Form.Item
          label="主问题"
          name="types"
          rules={[{ required: true, message: "请选择主问题" }]}
        >
          <Select
            mode="multiple"
            placeholder="请选择主问题"
            options={tagData}
            allowClear
            showArrow
            showSearch
            optionFilterProp="label"
          />
        </Form.Item>
        <Form.Item label="次问题" name="reason">
          <TextArea rows={2} />
        </Form.Item>
        <Form.Item
          label="联系结果"
          name="result"
          rules={[{ required: true, message: "请选择联系结果" }]}
        >
          <Select
            placeholder="请选择联系结果"
            options={concatResultList}
            allowClear
            showArrow
            showSearch
            optionFilterProp="label"
          />
        </Form.Item>
        <Form.Item label="用户配合度" name="adaptability">
          <Select
            placeholder="请选择用户配合度"
            options={[
              { name: "配合", value: "配合" },
              { name: "一般配合", value: "一般配合" },
              { name: "完全不配合", value: "完全不配合" },
            ]}
            allowClear
            showArrow
            showSearch
            optionFilterProp="label"
          />
        </Form.Item>
        <Form.Item
          label="问题来源"
          name="category"
          rules={[{ required: true, message: "请选择问题来源" }]}
        >
          <Select
            placeholder="请选择问题来源"
            options={serviceProblemType}
            allowClear
            showArrow
            showSearch
            optionFilterProp="label"
          />
        </Form.Item>
        {(() => {
          const legacyClassify = currentEditRecord?.classify && !classifyOptions.includes(currentEditRecord.classify)
            ? currentEditRecord.classify
            : null;
          return (
            <Form.Item
              label="沟通类型"
              name="classify"
              style={{ gridColumn: "1 / -1" }}
              rules={[{ required: true, message: "请选择沟通类型" }]}
            >
              <Radio.Group
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  rowGap: 8,
                }}
              >
                {classifyOptions.map((item) => (
                  <Radio key={item} value={item}>{item}</Radio>
                ))}
                {legacyClassify && (
                  <Radio value={legacyClassify}>{legacyClassify}</Radio>
                )}
              </Radio.Group>
            </Form.Item>
          );
        })()}
        {type == "serviceTaskDisposeAdd" ? (
          <Form.Item shouldUpdate noStyle>
            {() => {
              if (data.type == "离线车辆") {
                return (
                  <>
                    <Form.Item label="车辆离线原因" name="offlineReason">
                      <Select
                        placeholder="请选择车辆离线原因"
                        options={carOffLineCauseType}
                        allowClear
                        showArrow
                        showSearch
                        optionFilterProp="label"
                      />
                    </Form.Item>
                    <Form.Item label="预计复工时间" name="time">
                      <Select
                        placeholder="请选择预计复工时间"
                        options={carPredictWorkTime}
                        allowClear
                        showArrow
                        showSearch
                        optionFilterProp="label"
                      />
                    </Form.Item>
                  </>
                );
              }
            }}
          </Form.Item>
        ) : null}
        <Form.Item shouldUpdate={(prev, cur) => prev.classify !== cur.classify} noStyle>
          {() => {
            const contentRequired = isReliefClassify(form.getFieldValue("classify"));
            return (
              <Form.Item
                label="记录内容"
                name="content"
                style={{ gridColumn: "1 / -1" }}
                rules={contentRequired ? [{ required: true, message: "请填写记录内容" }] : undefined}
              >
                <TextArea rows={4} placeholder={contentRequired ? "减/免责沟通时记录内容必填" : undefined} />
              </Form.Item>
            );
          }}
        </Form.Item>
         <Form.Item label="联系人身份" name="contactIdentity" 
            rules={[{ required: true, message: "联系人身份" }]}>
          <Select
            placeholder="请选择联系人身份"
            options={[
              { name: "车队长", value: "车队长" },
              { name: "司机", value: "司机" },
              { name: "负责人", value: "负责人" },
            ]}
            allowClear
            showArrow
            showSearch
            optionFilterProp="label"
          />
        </Form.Item> 
          <Form.Item
            label="联系人"
            name="contactName"
            rules={[{ required: true, message: "联系人" }]}
          >
            <Input placeholder="联系人" />
          </Form.Item>
       
          <Form.Item
            label="联系电话"
            name="tel"
            rules={[{ required: true, message: "请输入联系电话" }]}
          >
            <Input placeholder="请输入联系电话" />
          </Form.Item>
        <Form.Item label="客服预约类型" name="appointmentType">
          <Select
            placeholder="请选择客服预约类型"
            allowClear
            options={[
              { label: "电话预约", value: 1 },
              { label: "微信预约", value: 2 },
              { label: "企业微信预约", value: 3 },
              { label: "短信预约", value: 4 },
              { label: "不需预约", value: 5 },
            ]}
          />
        </Form.Item>
        <Form.Item label="运维方式" name="operateMethod">
          <Radio.Group>
            <Radio value={1}>线上运维</Radio>
            <Radio value={2}>线下运维</Radio>
          </Radio.Group>
        </Form.Item>
        <div style={{ gridColumn: "1 / -1", marginBottom: 16 }}>
          <Switch
            checked={showUploadImageVideo}
            checkedChildren="上传视频/图片/录音"
            unCheckedChildren="上传视频/图片/录音"
            onChange={IfUploadImageVideo}
            disabled={isFormDisabled || sellCar}
            style={{ marginBottom: "5px" }}
          />
          {showUploadImageVideo && (
            <div style={isFormDisabled ? { pointerEvents: "none", opacity: 0.6 } : undefined}>
              {sellCar && (
                <div style={{ color: '#ff4d4f', fontSize: 12, marginBottom: 4 }}>* 卖车状态下必须上传录音</div>
              )}
              <UploadImageVideo
                key={uploadFilesVersion}
                businessName="上传视频/图片/录音"
                uploadFilesChange={(successList: any) => {
                  setUploadTouched(true);
                  setUploadSuccessList(successList);
                  if (type === "serviceTaskDisposeAdd") {
                    setAutoCarryUploadFiles(successList);
                  }
                }}
                canUploadVideo
                defaultUploadFiles={uploadDefaultFiles}
                limitSize={500}
                multiple
                acceptTypes=".mp3,.mp4,.jpg,.jpeg,.png,.gif,.awb,.avi,.mov,.wmv,.flv,.mkv,image/*,video/*,audio/*"
              />
            </div>
          )}
        </div>
        {type == "serviceTaskDisposeAdd" ||
          type == "serviceTaskDisposeEdit" ||
          type == "serviceTaskBatchAdd" ? (
          <Form.Item
            label="客服任务处理状态"
            name="treatmentStateType"
            rules={[{ required: true, message: "请选择客服任务处理状态" }]}
          >
            <Select
              placeholder="请选择客服任务处理状态"
              options={treatmentState}
              allowClear
              showArrow
              showSearch
              optionFilterProp="label"
              onChange={(e) => {
                if (e == 15) {
                  setExpectedTime(true);
                  setTimeout(() => {
                    form.setFieldValue("expectedTime", dayjs());
                  }, 100);
                } else {
                  setExpectedTime(false);
                }
                //卖车  13
                if (e == 13) {
                  setSellCar(true);
                  setIfUploadImageVideo(true);
                } else {
                  setSellCar(false);
                  form.setFieldValue("sellCarReason", undefined);
                }
              }}
            />
          </Form.Item>
        ) : null}
        {sellCar && (
          <Form.Item
            label="卖车原因"
            name="sellCarReason"
            rules={[{ required: true, message: "请选择卖车原因" }]}
          >
            <Select
              placeholder="请选择卖车原因"
              options={sellCarReasonOptions}
              allowClear
              showArrow
              showSearch
              optionFilterProp="label"
            />
          </Form.Item>
        )}
        {expectedTime && (
          <Form.Item
            label="期望完成时间"
            name="expectedTime"
            rules={[{ required: true, message: "请选择期望完成时间" }]}
          >
            <DatePicker showTime style={{ width: "100%" }} />
          </Form.Item>
        )}
        </div>
        <Divider orientation="left">审核记录</Divider>
        <Table<CustomerRecordHistoryDto>
          rowKey={(record) => String(record.id ?? `${record.userId ?? ""}-${record.createTime ?? ""}`)}
          size="small"
          loading={historyLoading}
          pagination={false}
          dataSource={historyList}
          scroll={{ x: 600 }}
          columns={[
            {
              title: "审核人员",
              dataIndex: "nickname",
              render: (value: string | null | undefined) => value || "-",
            },
            {
              title: "审核时间",
              dataIndex: "createTime",
              width: 180,
              render: (value: string | null | undefined) =>
                value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "-",
            },
            {
              title: "审核结果",
              dataIndex: "approvalStatusDesc",
              width: 140,
              render: (value: string | null | undefined) => value || "-",
            },
            {
              title: "备注",
              dataIndex: "remark",
              render: (value: string | null | undefined) => value || "-",
            },
          ]}
          locale={{
            emptyText: historyCustomerRecordId ? "暂无审核记录" : "当前记录保存后可查看审核记录",
          }}
        />
        {/* <Form.Item shouldUpdate={expectedTime} noStyle>
          {() => {
            if (form.getFieldValue('treatmentStateType') == 9) {
              setTimeout(() => {
                form.setFieldValue('expectedTime', dayjs())
              }, 100);
              return (
                <Form.Item
                  label="期望完成时间"
                  name="expectedTime"
                  rules={[
                    { required: true, message: '请选择期望完成时间' }
                  ]}
                >
                  <DatePicker showTime style={{ width: '100%' }} />
                </Form.Item>
              )
            }
          }}
        </Form.Item> */}
      </Form>
    </Modal>
  );
};

export default OperateService;
